var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAstropay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6828 30.131C38.2158 30.131 39.7193 30.2514 41.1865 30.4838L44.8714 39.6048C42.3584 38.5268 39.5906 37.9304 36.6828 37.9304C30.114 37.9304 24.2564 40.9754 20.4442 45.7312H11.2C15.9334 36.4702 25.5682 30.131 36.6828 30.131Z",
    fill: "#00DBBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4207 11.2814L40.0707 27.7132C38.9563 27.5928 37.8251 27.5312 36.6785 27.5312C35.0041 27.5312 33.3619 27.6628 31.7589 27.9162L29.2249 21.647L26.1043 29.368C21.8357 30.9052 17.9997 33.3468 14.8259 36.4604L24.9997 11.28H33.4193L33.4207 11.2814Z",
    fill: "#053634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstropay);
export default __webpack_public_path__ + "static/media/astropay.842e1de2ed363a49d7348c12f9f8af45.svg";
export { ForwardRef as ReactComponent };